import LeadAssignmentTab from './lead-assignment';

export default LeadAssignmentTab;
